export default class CreateTransferOrderLine {
    orderNo:number;
    sku:string;
    productName:string;
    productId :number;
    orderQty:number;
}